<template>
  <div>
        <b-form-group v-if="registrySettingsGlobalReports.length>0" label-align="left" :label="$t('Show reports tab')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-checkbox size="lg" @change="ChangeSettingReportsTab" switch class="mt-2" v-model="registrySettingsGlobalReports[0].raw_values[0].value" unchecked-value="0" value="1"/>
      </b-form-group>
    <table-manager @filterChanged="filterChanged"  @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
        v-if="availReport"
        :items="availReport"
        :fields="fields"
        @ClickOnDeleteButton="ClickOnDeleteButton"
        @ClickOnEditButton="editItem"
        :filter="filter"
        :perPage="perPage"
        :currentPage="currentPage"
        v-model="totalRows"
        isDelete="true"
        isEdit="true"/>
    <table-manager-bottom
        :totalRows="totalRows" :perPage="perPage"
        v-model="currentPage"/>
    <editModal :editItem="selectedAvailReps"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  data () {
    return {
      fields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'group_id',
          label: this.$i18n.t('Group'),
          sortable: true,
          formatter: (val, key, item) => {
            if (val === 0) {
              return this.$t('All') + '(0)'
            }
            for (let el of this.groups) {
              if (val === el.group_id) {
                return el.group_name + '(' + val + ')'
              }
            }
            return val
          }},
        {key: 'is_enabled', label: this.$i18n.t('Active'), sortable: true, formatter: (val, key, item) => { return val ? this.$t('Yes') : this.$t('No') }},
        {key: 'available_reports',
          label: this.$i18n.t('Available reports'),
          sortable: true,
          formatter: (val, key, item) => { return this.reportsEnum(val) }},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedAvailReps: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1,
      reportsArray: []
    }
  },
  components: {
    editModal
  },
  methods: {
    ChangeSettingReportsTab (checked) {
      let tmp = JSON.parse(JSON.stringify(this.registrySettingsGlobalReports[0]))
      tmp.object_id = 0
      tmp.raw_values[0].value = String(checked)
      this.$store.dispatch('Settings/UPDATE_REGISTRY_SETTING', tmp).then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.$root.$emit('makeToasts')
        }
      })
      setTimeout(this.$store.dispatch, 500, 'Settings/GET_REGISTRY_SETTINGS', {group_id: 15, object_id: 0})
    },
    reportsEnum (val) {
      let ret = ''
      if (val & 1) {
        ret += '(' + this.$i18n.t('Full statistics') + ') '
      }
      if (val & 2) {
        ret += '(' + this.$i18n.t('Blocking') + ') '
      }
      if (val & 4) {
        ret += '(' + this.$i18n.t('Sessions') + ')'
      }
      if (val & 8) {
        ret += '(' + this.$i18n.t('Traffic') + ')'
      }
      if (val & 16) {
        ret += '(' + this.$i18n.t('Telephony report') + ')'
      }
      if (val & 32) {
        ret += '(' + this.$i18n.t('Notifications') + ')'
      }
      return ret
    },
    reportsToArray (val) {
      let ret = []
      if (val & 1) {
        ret.push(1)
      }
      if (val & 2) {
        ret.push(2)
      }
      if (val & 4) {
        ret.push(4)
      }
      if (val & 8) {
        ret.push(8)
      }
      if (val & 16) {
        ret.push(16)
      }
      if (val & 32) {
        ret.push(32)
      }
      return ret
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', 'Are you sure you want to delete one of "Customer reports?"', this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_AVAIL_REPORTS_SETTINGS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_AVAIL_REPORTS_SETTINGS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    editItem (item) {
      this.selectedAvailReps = JSON.parse(JSON.stringify(item))
      this.selectedAvailReps.reports = this.reportsToArray(item.available_reports)
      this.$bvModal.show('modalEditAvailReports')
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    },
    showAdd () {
      this.selectedAvailReps = {
        group_id: 0,
        id: 0,
        is_enabled: 0,
        available_reports: 0,
        reports: []
      }
      this.$bvModal.show('modalEditAvailReports')
    }
  },
  computed: {
    groups () {
      return this.$store.getters['Users/GROUPS']
    },
    availReport () {
      return this.$store.getters['Settings/AVAIL_REPORTS_SETTINGS']
    },
    registrySettingsGlobalReports () {
      return this.$store.getters['Settings/REGISTRY_SETTINGS'].filter(el => {
        return el.name === 'customer_portal_show_reports'
      })
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_REGISTRY_SETTINGS', {group_id: 15, object_id: 0})
    this.$store.dispatch('Settings/GET_AVAIL_REPORTS_SETTINGS')
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/customerPortal/reports/main.vue